import { IconButton, Paper, Typography, styled } from '@mui/material';

export const PortfolioPageWrap = styled('section')({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
});

export const PortfolioGoBackSection = styled(Paper)(() => ({
	position: 'relative',
	borderRadius: '10px',
	padding: '14px 16px',
	display: 'flex',
	alignItems: 'center',
	margin: '0 !important',
	gap: '8px',
	justifyContent: 'flex-start',
}));

export const PortfolioTitle = styled(Typography)(({ theme }) => ({
	color: theme.palette.primary.main,
	textAlign: 'center',
}));

export const PortfolioGoBackButton = styled(IconButton)(() => ({}));
